import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SystemNotification } from '@shared/interfaces/system-notification/system-notification.interface';
import { LightProtectionReferencesService } from '@shared/service/light-protection-references/light-protection-references.service';
import { SnackbarService } from '@shared/service/snackbar/snackbar.service';
import { SystemNotificationService } from '@shared/service/system-notification/system-notification.service';
import { genericErrorAction } from '@store/application/application.actions';
import { catchError, map, of, switchMap } from 'rxjs';

import { systemNotifications } from './system-notifications.actions';

@Injectable()
export class SystemNotificationsEffects {
  loadReferences = createEffect(() =>
    this.actions$.pipe(
      ofType(systemNotifications.load),
      switchMap(() =>
        this.systemNotificationService.getSystemNotifications().pipe(
          map((response: Array<SystemNotification>) =>
            systemNotifications.loadSuccess({ systemNotifications: response })
          ),
          catchError(() => of(genericErrorAction({})))
        )
      )
    )
  );

  loadReferenceById = createEffect(() =>
    this.actions$.pipe(
      ofType(systemNotifications.loadSystemNotification),
      switchMap((payload: { id: number }) =>
        this.systemNotificationService.getSystemNotificationById(payload.id).pipe(
          map((response: SystemNotification) =>
            systemNotifications.loadSystemNotificationSuccess({ systemNotification: response })
          ),
          catchError(() => of(genericErrorAction({})))
        )
      )
    )
  );

  deleteReference = createEffect(() =>
    this.actions$.pipe(
      ofType(systemNotifications.delete),
      switchMap((payload: { systemNotification: SystemNotification }) =>
        this.systemNotificationService.deleteSystemNotification(payload.systemNotification.id).pipe(
          map(() => {
            console.log(`Deleted - ${payload.systemNotification.title}`);
            this.snackbarService.success(`Deleted - ${payload.systemNotification.id}`);
            return systemNotifications.load();
          }),
          catchError(() => of(genericErrorAction({})))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly lightProtectionReferenceService: LightProtectionReferencesService,
    private readonly systemNotificationService: SystemNotificationService,
    private readonly snackbarService: SnackbarService
  ) {}
}
